goog.provide("shadow.js.shim.module$dayjs$locale$de");
goog.provide("module$shadow_js_shim_module$dayjs$locale$de");
shadow.js.shim.module$dayjs$locale$de = shadow.js.nativeProvides["dayjs/locale/de"] = require("dayjs/locale/de");
module$shadow_js_shim_module$dayjs$locale$de.default = shadow.js.shim.module$dayjs$locale$de;
